import { useRawMode } from '~/context/RawModeContext';

import List2MobileLegs from './LegsAds/List2MobileLegs';
import List2MobilePop from './PopAds/List2MobilePop';

const List2Mobile = () => {
  const { isRaw } = useRawMode();

  return isRaw ? <List2MobileLegs /> : <List2MobilePop />;
};

export default List2Mobile;
